import { queryOptions } from '@tanstack/react-query'

import { StaleTime } from '@core/query'

import { getLikedAudioIds } from '../services/getLikesAudio'
import { LikeQueryKey } from './queryKeys'

export const likedAudioIdsQuery = () =>
    queryOptions({
        queryKey: LikeQueryKey.likedAudioIds(),
        queryFn: ({ signal }) => getLikedAudioIds(signal),
        staleTime: StaleTime.Short,
    })
